import plataformaUserApi from '@/services/plataforma/user';

export default {
  async getUserById({ commit }, id) {
    try {
      const result = await plataformaUserApi.getUserById(id);
      return result.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getCategories(_, id) {
    return plataformaUserApi.getCategories(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  async patchCategories(_, { id, ...body }) {
    return plataformaUserApi.patchCategories({ id, body })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async getAllUsers({ commit }, users) {
    try {
      const result = await plataformaUserApi.getAllUsers(users);
      return result.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async patchUser({ commit }, data) {
    try {
      const newdata = {
        ...data
      };

      const result = await plataformaUserApi.patchUser(newdata);
      return result.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async postUser({ commit, rootState }, body) {
    const bodyUser = {
      ...body,

      firstAccessPath    : `${window.location.origin}${process.env.APPLICATION_ROUTE_BASE}/auth/password/new/`,
      applicationLogoUrl : rootState._core.application.logo.light
    };
    try {
      await plataformaUserApi.postUser(bodyUser);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async actionUpdateByUserPhoto({ rootState }, body) {
    try {
      const result = await plataformaUserApi.updateByUserPhoto(body);
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getAllAccessibilities({ commit }, accessibilities) {
    try {
      const result = await plataformaUserApi.getAllAccessibilities(accessibilities);
      return result.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getSafeARoles({ commit }) {
    return plataformaUserApi.getSafeARoles()
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async getUserEnrollments(_, { id, page, perPage, order, orderBy, name, filterPeriodId, categoriesIds, status, startDate, endDate }) {
    return plataformaUserApi.getUserEnrollments({ id, page, perPage, order, orderBy, name, filterPeriodId, categoriesIds, status, startDate, endDate })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async editUserEnrollment(_, data) {
    return plataformaUserApi.editUserEnrollment(data)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionChangeUserPassword(_, data) {
    return this.$services._core.user().changeUserPasswordManually(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  },
  actionGetUserRolesContext({ commit }) {
    return plataformaUserApi.getUserRolesContext()
      .then(response => {
        commit('SET_USER_CONTEXT', response.data);

        Promise.resolve();
      })
      .catch(error => {
        Promise.reject(error.response.data);
      });
  },
  async actionChangeAnotherUserPassword({ rootState }, { id, password }) {
    try {
      const result = await plataformaUserApi.editUserPassword({
        id,
        password,
        applicationUrl: this.getters["_core/auth/getCurrentRoleHostname"]
      });
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  }
};
